<div class="aircraft-popup">
    <div *ngIf="isLoading" class="loading-spinner">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="!isLoading">
        <div class="row pb-2">
            <div class="col-10 pl-4 pb-2 aircraft-title">
                <img src="../../../../assets/img/plane.png" />&nbsp;{{
                    aircraftWatch?.tailNumber
                }}&nbsp;
            </div>
            <div class="col-2">
                <app-favorite-icon
                    [favoriteData]="aircraftWatch"
                    [callbackComponent]="favoriteCallbackComponent"
                    [customers]="customers"
                    (click)="$event.stopPropagation()"
                    (favoriteClick)="favoriteClick($event)"
                ></app-favorite-icon>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-12"><hr class="info-values" /></div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Company</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p
                    matTooltip="No Information is available for this item on JETNET. You can manually add the information by accessing our customer manager section."
                    matTooltipPosition="below"
                    [matTooltipDisabled]="hasJetNetInformation"
                >
                    {{ companyDisplayText }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>FAA Registered Owner</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>
                    {{
                        aircraftWatch?.faaRegisteredOwner
                            | NullOrEmptyToDefault
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Flight Number</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>
                    {{
                        aircraftWatch?.atcFlightNumber | NullOrEmptyToDefault
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Make/Model</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>
                    {{
                        aircraftWatch?.aircraftMakeModel | NullOrEmptyToDefault
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>On Ground</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>
                    {{
                        aircraftWatch?.isAircraftOnGround | booleanToText
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Last Quote</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p
                    matTooltip="There is no previous quote as this location has not been quoted prior."
                    matTooltipPosition="below"
                    [matTooltipDisabled]="aircraftWatch?.lastQuote != ''"
                >
                    {{
                        aircraftWatch?.lastQuote
                            | NullOrEmptyToDefault
                                : "NO PREVIOUS QUOTE AVAILABLE"
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Origin</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>{{ aircraftWatch?.origin }}&nbsp;</p>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-6 info-labels">
                <p>Destination</p>
            </div>
            <div class="col-6 pl-4 info-values">
                <p>
                    {{
                        aircraftWatch?.destination
                            | NullOrEmptyToDefault : defaultStringsEnum.na
                    }}&nbsp;
                </p>
            </div>
        </div>
        <div
            class="actions"
        >
            <button *ngIf="!isCustomerManagerButtonDisabled"
                ni-button
                [view]="'gray'"
                class="customer-manager-button"
                [disabled]="isCustomerManagerButtonDisabled"
                (click)="
                    goToCustomerManager(aircraftWatch.customerInfoByGroupId)
                "
            >
                Customer Manager
            </button>

            <button *ngIf="isCustomerManagerButtonDisabled"
                ni-button
                [disabled]="!isCustomerManagerButtonDisabled"
                [view]="'accent'"
                (click)="addAircraft()"
            >
                Add Aircraft
            </button>

            <button
                ni-button
                [view]="'accent'"
                [disabled]="isJetNetButtonDisabled"
                (click)="openJetNetInformation()"
            >
                Access JETNET
            </button>
        </div>
    </div>
</div>
